import './../styles/main.css';
import SendMail from "../components/sendmail/Sendmail";
import { Helmet } from "react-helmet";
function Contacts (){
    return (
        <>
          <Helmet>
            <title>Контакты</title>
            <meta name="description" content="Контакты, связаться"/>
          </Helmet>
          <SendMail/>
          <div className='link'>
            <a href="mailto:info@ikochetkov.ru"  data-title="Email -  info@ikochetkov.ru" >  Email -  info@ikochetkov.ru</a>
          </div>
        </>
    );
}

export default Contacts;